import actions from './constants';

export const applyRole = (approved, role, permissions) => ({
  type: actions.APPLY_ROLE,
  approved,
  role,
  permissions,
});

export const applyUserGroups = (userGroups) => ({
  type: actions.APPLY_USER_GROUPS,
  userGroups,
});

export const fetchUserError = (error) => ({
  type: actions.FETCH_USER_ERROR,
  error,
});

export const roleUpdated = (code, result) => ({
  type: actions.ROLE_UPDATED,
  code,
  result,
});

export const roleChanged = (result) => ({
  type: actions.ROLE_CHANGED,
  result,
});

export const fetchUsers = (
  category,
  page,
  pageSize,
  append,
  filter = undefined,
  requiresFilter = false,
  minFilterLength = undefined,
) => ({
  type: actions.FETCH_USERS,
  category,
  page,
  pageSize,
  append,
  filter,
  requiresFilter,
  minFilterLength,
});

export const refreshUsers = (category, page) => ({
  type: actions.REFRESH_USERS,
  category,
  page,
});

export const refreshUsersMetrics = (category) => ({
  type: actions.REFRESH_USERS_METRICS,
  category,
});

export const toggleUsersColumnOrderBy = (category, orderByColumn) => ({
  type: actions.TOGGLE_USERS_COLUMN_ORDER_BY,
  category,
  orderByColumn,
});

export const toggleUsersSingleSorting = (category) => ({
  type: actions.TOGGLE_USERS_SINGLE_SORTING,
  category,
});

export const toggleUserSelected = (category, code) => ({
  type: actions.TOGGLE_USER_SELECTED,
  category,
  code,
});

export const toggleUsersSelected = (category, selected) => ({
  type: actions.TOGGLE_USERS_SELECTED,
  category,
  selected,
});

export const updateUsersFilter = (category, value) => ({
  type: actions.UPDATE_USERS_FILTER,
  category,
  value,
});

export const updateUsersRoleFilter = (category, value) => ({
  type: actions.UPDATE_USERS_ROLE_FILTER,
  category,
  value,
});

export const updateUsersFlags = (category, approvedFlag, unapprovedFlag, archivedFlag) => ({
  type: actions.UPDATE_USERS_FLAGS,
  category,
  approvedFlag,
  unapprovedFlag,
  archivedFlag,
});

export const showUsers = (category, append, pageSize, results, resultsCount, totalPages, currentPage) => ({
  type: actions.SHOW_USERS,
  category,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
});

export const showUsersMetrics = (category, results) => ({
  type: actions.SHOW_USERS_METRICS,
  category,
  results,
});

export const showUsersError = (category, error) => ({
  type: actions.SHOW_USERS_ERROR,
  category,
  error,
});

export const showUsersMetricsError = (category, error) => ({
  type: actions.SHOW_USERS_METRICS_ERROR,
  category,
  error,
});

export const closeUsers = ({ category }) => ({
  type: actions.CLOSE_USERS,
  category,
});

export const fetchUser = (category, code) => ({
  type: actions.FETCH_USER,
  category,
  code,
});

export const showUser = (category, code, result) => ({
  type: actions.SHOW_USER,
  category,
  code,
  result,
});

export const showUserError = (category, code, error) => ({
  type: actions.SHOW_USER_ERROR,
  category,
  code,
  error,
});

export const closeUser = ({ category, code }) => ({
  type: actions.CLOSE_USER,
  category,
  code,
});

export const applyCurrentUser = (result) => ({
  type: actions.APPLY_CURRENT_USER,
  result,
});

export const fetchGuestUser = () => ({
  type: actions.FETCH_GUEST_USER,
});

export const applyGuestUser = (result) => ({
  type: actions.APPLY_GUEST_USER,
  result,
});

export const fetchGuestUserError = () => ({
  type: actions.FETCH_GUEST_USER_ERROR,
});

export const toggleUserApproved = (category, code) => ({
  type: actions.UPDATE_USER_APPROVED,
  category,
  code,
});

export const updateApprovedSuccess = (category, code, result, approved) => ({
  type: actions.UPDATE_USER_APPROVED_SUCCESS, category, code, result, approved,
});

export const updateApprovedError = (category, code, name, error) => ({
  type: actions.UPDATE_USER_APPROVED_ERROR, category, code, error, name,
});

export const toggleUserSearchable = (category, code) => ({
  type: actions.UPDATE_USER_SEARCHABLE,
  category,
  code,
});

export const updateSearchableSuccess = (category, code, result, searchable) => ({
  type: actions.UPDATE_USER_SEARCHABLE_SUCCESS, category, code, result, searchable,
});

export const updateSearchableError = (category, code, name, error) => ({
  type: actions.UPDATE_USER_SEARCHABLE_ERROR, category, code, error, name,
});

export const toggleMyApproval = () => ({
  type: actions.TOGGLE_MY_APPROVAL,
});

export const toggleMyArchived = () => ({
  type: actions.TOGGLE_MY_ARCHIVED,
});

export const applyRoleActions = (roleActions) => ({
  type: actions.APPLY_ROLE_ACTIONS,
  roleActions,
});

export const showArchiveUser = (category, code) => ({
  type: actions.SHOW_ARCHIVE_USER,
  category,
  code,
});

export const showArchiveUsers = (category) => ({
  type: actions.SHOW_ARCHIVE_USERS,
  category,
});

export const hideArchiveUser = () => ({
  type: actions.HIDE_ARCHIVE_USER,
});

export const archiveUsers = (items, reason, disableTokens, archiveRequests) => ({
  type: actions.ARCHIVE_USERS,
  items,
  reason,
  disableTokens,
  archiveRequests,
});

export const restoreUsers = ({ items }) => ({
  type: actions.RESTORE_USERS,
  items,
});

export const archiveUsersSuccess = (items, isArchival) => ({
  type: actions.ARCHIVE_USERS_SUCCESS,
  items,
  isArchival,
});

export const archiveUsersError = (items) => ({
  type: actions.ARCHIVE_USERS_ERROR,
  items,
});

export const toggleUsersPresentation = (category, display) => ({
  type: actions.TOGGLE_USERS_PRESENTATION,
  category,
  display,
});

export const updateUserPanels = (category, code, index) => ({
  type: actions.UPDATE_USER_PANELS,
  category,
  code,
  index,
});
